/**
 * Dados mock centralizados para desenvolvimento sem API.
 * Substitua por chamadas reais quando o backend estiver disponível.
 */

import type { User, Project, ProjectMember } from '@dt-pm/core';

// ─── Usuário logado ───────────────────────────────────────────────────────────
export const MOCK_ME: User = {
  id: 'u-1',
  name: 'Nome Sobrenome',
  email: 'nome.sobrenome@email.com',
  role: 'ADMIN',
  status: 'ACTIVE',
  avatarUrl: null,
  createdAt: '2025-01-01T00:00:00Z',
  updatedAt: '2025-01-01T00:00:00Z',
};

// ─── Membros ──────────────────────────────────────────────────────────────────
export const MOCK_MEMBERS: ProjectMember[] = [
  {
    id: 'pm-1',
    projectId: 'p-1',
    role: 'ADMIN',
    active: true,
    createdAt: '2025-01-01T00:00:00Z',
    user: {
      id: 'u-2',
      name: 'Maria Clara',
      email: 'maria.clara@ipnet.cloud',
      role: 'ADMIN',
      status: 'ACTIVE',
      avatarUrl: null,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
  },
  {
    id: 'pm-2',
    projectId: 'p-1',
    role: 'MEMBER',
    active: true,
    createdAt: '2025-01-01T00:00:00Z',
    user: {
      id: 'u-3',
      name: 'João Pereira',
      email: 'joao.pereira@ipnet.cloud',
      role: 'MEMBER',
      status: 'ACTIVE',
      avatarUrl: null,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
  },
  {
    id: 'pm-3',
    projectId: 'p-1',
    role: 'PM',
    active: true,
    createdAt: '2025-01-01T00:00:00Z',
    user: {
      id: 'u-4',
      name: 'Lucas Fernandes',
      email: 'lucas.fernandes@ipnet.cloud',
      role: 'PM',
      status: 'ACTIVE',
      avatarUrl: null,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
  },
  {
    id: 'pm-4',
    projectId: 'p-1',
    role: 'MEMBER',
    active: true,
    createdAt: '2025-01-01T00:00:00Z',
    user: {
      id: 'u-5',
      name: 'Rita Azevedo',
      email: 'rita.azevedo@ipnet.cloud',
      role: 'MEMBER',
      status: 'ACTIVE',
      avatarUrl: null,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
  },
  {
    id: 'pm-5',
    projectId: 'p-1',
    role: 'MEMBER',
    active: true,
    createdAt: '2025-01-01T00:00:00Z',
    user: {
      id: 'u-6',
      name: 'Ana Silva',
      email: 'ana.silva@ipnet.cloud',
      role: 'MEMBER',
      status: 'ACTIVE',
      avatarUrl: null,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
  },
];

// ─── Projetos ─────────────────────────────────────────────────────────────────
export const MOCK_PROJECTS: Project[] = [
  {
    id: 'p-1',
    code: 'PRJ-101',
    name: 'Migração Google Workspace Enterprise (15k Usuários)',
    status: 'PENDING_ADMIN_APPROVAL',
    methodology: 'SPRINT',
    origin: 'MANUAL',
    spaceId: 's-1',
    spaceName: 'Enterprise Cloud',
    client: { id: 'c-1', name: 'Banco Santander Brasil S.A.', segment: 'Financeiro', createdAt: '2025-01-01T00:00:00Z' },
    departments: ['Cloud & Infra', 'Segurança'],
    temperature: 'good',
    startDate: '2025-06-01',
    endDate: '2025-12-31',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'p-2',
    code: 'PRJ-102',
    name: 'Implementação Data Lakehouse & BigQuery IA',
    status: 'PENDING_CONFIGURATION',
    methodology: 'KANBAN',
    origin: 'MANUAL',
    spaceId: 's-1',
    spaceName: 'Analytics & Big Data',
    client: { id: 'c-2', name: 'iFood Brasil Tecnologia', segment: 'Alimentos & Tech', createdAt: '2025-01-01T00:00:00Z' },
    departments: ['Data & Analytics'],
    temperature: 'warning',
    startDate: '2025-06-01',
    endDate: '2025-12-31',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'p-3',
    code: 'PRJ-103',
    name: 'Modernização de Microsserviços e Kubernetes (GKE)',
    status: 'ACTIVE',
    methodology: 'SPRINT',
    origin: 'MANUAL',
    spaceId: 's-2',
    spaceName: 'DevOps & SRE',
    client: { id: 'c-3', name: 'Nubank Pagamentos S.A.', segment: 'Fintech', createdAt: '2025-01-01T00:00:00Z' },
    departments: ['DevOps', 'Engenharia'],
    temperature: 'good',
    startDate: '2025-03-01',
    endDate: '2025-09-30',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'p-4',
    code: 'PRJ-104',
    name: 'Rollout Global de IA Generativa com Vertex AI',
    status: 'ACTIVE',
    methodology: 'KANBAN',
    origin: 'FRESHW',
    spaceId: 's-2',
    spaceName: 'Inovação & IA',
    client: { id: 'c-4', name: 'Hospital Albert Einstein', segment: 'Saúde', createdAt: '2025-01-01T00:00:00Z' },
    departments: ['Inteligência Artificial'],
    temperature: 'critical',
    startDate: '2025-01-15',
    endDate: '2025-07-15',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'p-5',
    code: 'PRJ-105',
    name: 'Arquitetura Zero Trust e BeyondCorp Enterprise',
    status: 'ACTIVE',
    methodology: 'SPRINT',
    origin: 'MANUAL',
    spaceId: 's-3',
    spaceName: 'Cybersecurity',
    client: { id: 'c-5', name: 'Magazine Luiza (Magalu)', segment: 'Varejo & E-commerce', createdAt: '2025-01-01T00:00:00Z' },
    departments: ['Segurança', 'Governança'],
    temperature: 'warning',
    startDate: '2025-02-01',
    endDate: '2025-08-01',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'p-6',
    code: 'PRJ-106',
    name: 'Automação de CI/CD e FinOps de Nuvem',
    status: 'COMPLETED',
    methodology: 'KANBAN',
    origin: 'MANUAL',
    spaceId: 's-3',
    spaceName: 'FinOps & Cloud',
    client: { id: 'c-6', name: 'Ambev Global Operations', segment: 'Bebidas & Bens de Consumo', createdAt: '2024-01-01T00:00:00Z' },
    departments: ['Cloud & Infra', 'Financeiro'],
    temperature: 'good',
    startDate: '2024-06-01',
    endDate: '2024-12-31',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-12-31T00:00:00Z',
  },
  {
    id: 'p-7',
    code: 'PRJ-107',
    name: 'Implementação de Solução Contact Center AI (CCAI)',
    status: 'PENDING_ADMIN_APPROVAL',
    methodology: null,
    origin: 'FRESHW',
    spaceId: 's-1',
    spaceName: 'Atendimento & CX',
    client: { id: 'c-7', name: 'Localiza Rent a Car', segment: 'Mobilidade & Logística', createdAt: '2025-01-01T00:00:00Z' },
    departments: ['Customer Experience', 'TI'],
    temperature: 'warning',
    startDate: null,
    endDate: null,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'p-8',
    code: 'PRJ-108',
    name: 'Disaster Recovery e Multi-Region failover no GCP',
    status: 'PAUSED',
    methodology: 'SPRINT',
    origin: 'MANUAL',
    spaceId: 's-2',
    spaceName: 'Resiliência & Infra',
    client: { id: 'c-8', name: 'Stone Pagamentos', segment: 'Fintech', createdAt: '2025-01-01T00:00:00Z' },
    departments: ['Infraestrutura', 'SRE'],
    temperature: 'warning',
    startDate: '2025-02-01',
    endDate: '2025-10-01',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'p-9',
    code: 'PRJ-109',
    name: 'Governança e Catálogo de Dados com Dataplex',
    status: 'COMPLETED',
    methodology: null,
    origin: 'MANUAL',
    spaceId: 's-3',
    spaceName: 'Governança Corporativa',
    client: { id: 'c-9', name: 'Petrobras Distribuidora', segment: 'Energia & Petróleo', createdAt: '2025-01-01T00:00:00Z' },
    departments: ['Dados', 'Compliance'],
    temperature: 'good',
    startDate: null,
    endDate: null,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'p-10',
    code: 'PRJ-110',
    name: 'Auditoria de Segurança de Aplicações e PenTest',
    status: 'AUDITED',
    methodology: 'KANBAN',
    origin: 'MANUAL',
    spaceId: 's-1',
    spaceName: 'Segurança Ofensiva',
    client: { id: 'c-10', name: 'Suzano Papel e Celulose', segment: 'Indústria', createdAt: '2024-01-01T00:00:00Z' },
    departments: ['Segurança', 'Auditoria'],
    temperature: 'good',
    startDate: '2024-01-01',
    endDate: '2024-08-01',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-08-01T00:00:00Z',
  },
  {
    id: 'p-11',
    code: 'PRJ-111',
    name: 'Migração de SAP HANA para Google Cloud Bare Metal',
    status: 'ARCHIVED',
    methodology: 'SPRINT',
    origin: 'MANUAL',
    spaceId: 's-2',
    spaceName: 'ERP & Mission Critical',
    client: { id: 'c-11', name: 'Lojas Renner S.A.', segment: 'Varejo', createdAt: '2023-01-01T00:00:00Z' },
    departments: ['SAP', 'Infraestrutura'],
    temperature: 'good',
    startDate: '2023-06-01',
    endDate: '2023-12-31',
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2023-12-31T00:00:00Z',
  },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

/** Iniciais de um nome para usar em avatares. */
export function initials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

/** Cor de avatar baseada no id (determinística). */
const AVATAR_COLORS = [
  'bg-[#F7007B]',
  'bg-avatar-purple',
  'bg-info-solid',
  'bg-status-lime-solid',
  'bg-status-orange-solid',
  'bg-status-yellow-solid',
  'bg-[#AED74B]',
];
export function avatarColor(id: string): string {
  const idx = id.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0) % AVATAR_COLORS.length;
  return AVATAR_COLORS[idx] ?? 'bg-slate-500';
}
